import React from 'react';

import { Row, Col } from 'react-bootstrap';
// @ts-ignore no types for react-bootstrap-table
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { CircularProgress } from '@raptormaps/progress';
import { Stack } from '@raptormaps/layout';

import {
  ViewAllFarms,
  EditAllFarms,
  CreateFarms,
  DeleteFarms,
  RemoveUserButton,
  ManageWorkOrders,
  CompleteWorkOrders,
} from './OrganizationEditHelper';
import { FormattedMessage } from 'react-intl';
import type { OrgUser } from '../../api/types/OrgUser';

interface FarmPermittanceProps {
  users: OrgUser[];
  formatData: (cell: any, row: any, permission: string) => React.ReactNode;
  onRemoveUser: (user: OrgUser) => void;
  orgId: number;
}

/**
 * Table that renders the permissions for solar farms.
 * Formatting of ther headers can be found in the OrganizationEditHelper file.
 */
const FarmPermittance = ({ ...props }: FarmPermittanceProps) => {
  return (
    <Row>
      <Col xs={12}>
        {props.users?.length ? (
          <div className="panel">
            <BootstrapTable
              data={props.users}
              keyField="email"
              headerStyle={{ fontSize: '12px' }}
              bordered={false}
              className="rm-farm-permissions-table"
            >
              <TableHeaderColumn
                dataField="email"
                width="20%"
                dataAlign="left"
                className="rm-column-header"
              >
                <FormattedMessage
                  id="app.orgeditpage.email"
                  defaultMessage="Email"
                  description="Email column header"
                />
              </TableHeaderColumn>

              <TableHeaderColumn
                dataFormat={props.formatData}
                formatExtraData="canViewFarmsByDefault"
                dataAlign="center"
                width="5%"
                className="rm-column-header"
              >
                {ViewAllFarms}
              </TableHeaderColumn>

              <TableHeaderColumn
                dataFormat={props.formatData}
                formatExtraData="canEditFarmsByDefault"
                dataAlign="center"
                className="rm-column-header"
                width="5%"
              >
                {EditAllFarms}
              </TableHeaderColumn>

              <TableHeaderColumn
                dataFormat={props.formatData}
                formatExtraData="canCreateFarms"
                dataAlign="center"
                width="5%"
                className="rm-column-header"
              >
                {CreateFarms}
              </TableHeaderColumn>

              <TableHeaderColumn
                dataFormat={props.formatData}
                formatExtraData="canDeleteFarms"
                dataAlign="center"
                width="5%"
                className="rm-column-header"
              >
                {DeleteFarms}
              </TableHeaderColumn>

              <TableHeaderColumn
                dataFormat={props.formatData}
                formatExtraData="canManageWorkOrders"
                dataAlign="center"
                width="5%"
                className="rm-column-header"
              >
                {ManageWorkOrders}
              </TableHeaderColumn>

              <TableHeaderColumn
                dataFormat={props.formatData}
                formatExtraData="canCompleteWorkOrders"
                dataAlign="center"
                width="5%"
                className="rm-column-header"
              >
                {CompleteWorkOrders}
              </TableHeaderColumn>

              <TableHeaderColumn
                dataFormat={props.formatData}
                formatExtraData="isAdmin"
                dataAlign="center"
                width="5%"
                className="rm-column-header"
              >
                Admin
              </TableHeaderColumn>

              <TableHeaderColumn
                // @ts-ignore implicit any
                dataFormat={(row, cell) => (
                  <RemoveUserButton
                    onRemoveUser={props.onRemoveUser}
                    cell={cell}
                    users={props.users}
                  />
                )}
                dataAlign="center"
                width="5%"
                className="rm-column-header"
              >
                <FormattedMessage
                  id="app.orgeditpage.remove"
                  defaultMessage="Remove"
                  description="Remove column header"
                />
              </TableHeaderColumn>
            </BootstrapTable>
          </div>
        ) : (
          <Stack align="center" justify="center" style={{ padding: 24 }}>
            <CircularProgress size={75} />
          </Stack>
        )}
      </Col>
    </Row>
  );
};

export default FarmPermittance;
